import axios from "axios";
import * as bi from "react-icons/bi";
import Form from "../../components/Form";
import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';
const API_BASE = process.env.REACT_APP_API_URL;
const CALLBACK_URI = process.env.REACT_APP_CALLBACK_URL;

const Authenticate = ({ setToken, setId, setUser, setMessage, setClassName, setShow, setFormShow, setSuperuser, setLoading }) => {
    const [isLogin, setIsLogin] = useState(true);
    const [forgotPassword, setForgotPassword] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    const [password2, setPassword2] = useState('');
    const [showResendVerification, setShowResendVerification] = useState(false);
    const [verificationEmail, setVerificationEmail] = useState('');
    const navigate = useNavigate();
    // Keep resend verification visible across reopen
    useState(() => {
        const savedEmail = localStorage.getItem("pendingVerificationEmail");
        if (savedEmail) {
            setVerificationEmail(savedEmail);
            setShowResendVerification(true);
            setIsLogin(false); // Stay in signup mode
        }
    }, []);

    const LoginSubmit = e => {
        e.preventDefault();
        setLoading(true);
        setFormShow(false);
        const loginData = { 'username': username, 'password': password };
        axios.post(`${API_BASE}/rest-auth/signin/`, loginData)
            .then(response => {
                // Store token
                localStorage.setItem('token', response.data.token);
                setToken(response.data.token);

                // Store user ID - FIXED: access from response.data.user.id
                localStorage.setItem('user_id', response.data.user.id);
                setId(response.data.user.id);

                // Store username
                localStorage.setItem('user', username);
                setUser(username);

                // Set superuser status - FIXED: access from response.data.user.is_superuser
                const isSuperuser = response.data.user.is_superuser === true;
                localStorage.setItem('is_superuser', isSuperuser);
                setSuperuser(isSuperuser);

                setShow(true);
                setTimeout(() => setShow(false), 3500);
                setClassName(`bg-teal-100 border-t-4 border-teal-500 rounded-b text-teal-900 px-4 py-3 shadow-md transition duration-300 ease-in-out`);
                setMessage(`Successfully logged in as ${username}.`);

                // Redirect based on user role
                if (isSuperuser) {
                    navigate("/dashboard");
                } else {
                    navigate("/driver-dashboard");
                }

                setLoading(false);
            })
            .catch(err => {
                console.log('Login error:', err);
                setFormShow(true);
                setLoading(false);
                setClassName(`bg-red-100 border-t-4 border-red-500 rounded-b text-red-900 px-4 py-3 shadow-md transition duration-300 ease-in-out`);

                let errorMessage = 'Invalid credentials. Please try again.';
                if (err.response && err.response.data) {
                    const error = err.response.data;

                    // This will catch your 'Please verify your email' message
                    if (error.detail) {
                        errorMessage = error.detail;
                    } else if (error.non_field_errors) {
                        errorMessage = Array.isArray(error.non_field_errors)
                            ? error.non_field_errors[0]
                            : error.non_field_errors;
                    } else if (error.username) {
                        errorMessage = Array.isArray(error.username)
                            ? error.username[0]
                            : error.username;
                    } else if (error.password) {
                        errorMessage = Array.isArray(error.password)
                            ? error.password[0]
                            : error.password;
                    }
                }

                setMessage(errorMessage);
                setShow(true);
                setTimeout(() => setShow(false), 3500);
            });
    };

    const SignupSubmit = e => {
        e.preventDefault();
        setLoading(true);
        setFormShow(false);
        const signupData = { 'username': username, 'email': email, 'password': password, 'password2': password2 };

        console.log('📝 Submitting signup for:', { username, email });

        axios.post(`${API_BASE}/rest-auth/register/`, signupData)
            .then(res => {
                console.log('✅ Signup response:', res.data);
                const successMessage = res.data.detail || `${username} has been successfully registered.`;

                // Check if email sending failed - look for keywords
                const emailSendFailed =
                    successMessage.toLowerCase().includes('could not be sent') ||
                    successMessage.toLowerCase().includes('failed to send') ||
                    successMessage.toLowerCase().includes('contact support') ||
                    res.data.email_sent === false;

                if (emailSendFailed) {
                    console.warn('⚠️ Email sending failed during signup');
                    // Email sending failed - show warning and resend button
                    setClassName(`bg-yellow-100 border-t-4 border-yellow-500 rounded-b text-yellow-900 px-4 py-3 shadow-md transition duration-300 ease-in-out`);
                    setMessage(successMessage);
                    setShow(true);
                    setLoading(false);
                    setFormShow(true); // Keep form visible
                    setIsLogin(false);
                    setForgotPassword(false);
                    // Show resend verification button
                    setShowResendVerification(true);
                    setVerificationEmail(email);
                    localStorage.setItem("pendingVerificationEmail", email);
                    // Clear only password fields for security
                    setPassword('');
                    setPassword2('');

                    // Keep message visible longer
                    setTimeout(() => setShow(false), 10000);
                } else {
                    console.log('✅ Signup successful, email sent');
                    // Complete success - email was sent
                    setClassName(`bg-teal-100 border-t-4 border-teal-500 rounded-b text-teal-900 px-4 py-3 shadow-md transition duration-300 ease-in-out`);
                    setMessage(successMessage);
                    setShow(true);
                    setLoading(false);
                    // Don't navigate immediately - let user see the message
                    setTimeout(() => {
                        setShow(false);
                        // Optionally switch back to login view
                        setIsLogin(true);
                        navigate("/");
                    }, 5000);
                }
            })
            .catch(err => {
                console.error('❌ Signup error:', err);
                console.error('Error response:', err.response?.data);
                setLoading(false);
                setFormShow(true); // Show form again on error
                setClassName(`bg-red-100 border-t-4 border-red-500 rounded-b text-red-900 px-4 py-3 shadow-md transition duration-300 ease-in-out`);

                let errorMessage = 'Registration failed. Please try again.';
                if (err.response && err.response.data) {
                    const error = err.response.data;

                    if (error.detail) {
                        errorMessage = error.detail;
                    } else if (error.username) {
                        errorMessage = Array.isArray(error.username)
                            ? error.username[0]
                            : error.username;
                    } else if (error.email) {
                        errorMessage = Array.isArray(error.email)
                            ? error.email[0]
                            : error.email;
                    } else if (error.password) {
                        errorMessage = Array.isArray(error.password)
                            ? error.password[0]
                            : error.password;
                    } else if (error.non_field_errors) {
                        errorMessage = Array.isArray(error.non_field_errors)
                            ? error.non_field_errors[0]
                            : error.non_field_errors;
                    }
                }

                setMessage(errorMessage);
                setShow(true);
                setTimeout(() => setShow(false), 5000);

                // DO NOT clear form - keep all fields for retry
            });
    };

    const ForgotPasswordSubmit = e => {
        e.preventDefault();
        setLoading(true);
        setFormShow(false);
        const resetData = { 'email': email };
        axios.post(`${API_BASE}/rest-auth/password-reset/`, resetData)
            .then(res => {
                setShow(true);
                setTimeout(() => setShow(false), 3500);
                setClassName(`bg-teal-100 border-t-4 border-teal-500 rounded-b text-teal-900 px-4 py-3 shadow-md transition duration-300 ease-in-out`);
                setMessage(`Password reset link has been sent to ${email}.`);
                setLoading(false);
            })
            .catch(err => {
                console.log("Password reset request failed", err);
                setLoading(false);
                setFormShow(true);
                setClassName(`bg-red-100 border-t-4 border-red-500 rounded-b text-red-900 px-4 py-3 shadow-md transition duration-300 ease-in-out`);

                let errorMessage = 'Password reset failed. Please try again.';
                if (err.response && err.response.data) {
                    const error = err.response.data;
                    if (error.email) {
                        errorMessage = Array.isArray(error.email)
                            ? error.email[0]
                            : error.email;
                    } else if (error.non_field_errors) {
                        errorMessage = Array.isArray(error.non_field_errors)
                            ? error.non_field_errors[0]
                            : error.non_field_errors;
                    } else if (error.detail) {
                        errorMessage = error.detail;
                    }
                }

                setMessage(errorMessage);
                setShow(true);
                setTimeout(() => setShow(false), 3500);
            });
    };
    const ResendVerificationEmail = (e) => {
        e.preventDefault();
        setLoading(true);

        console.log(`📧 Attempting to resend verification email to: ${verificationEmail}`);

        axios.post(`${API_BASE}/rest-auth/resend-verification/`, { email: verificationEmail })
            .then(res => {
                console.log('✅ Resend verification response:', res.data);
                setShow(true);
                setTimeout(() => setShow(false), 5000);
                setClassName(`bg-teal-100 border-t-4 border-teal-500 rounded-b text-teal-900 px-4 py-3 shadow-md transition duration-300 ease-in-out`);
                setMessage(res.data.detail || 'Verification email has been resent! Please check your inbox and spam folder.');
                setLoading(false);

                // Only remove if truly successful
                if (res.status === 200 && !res.data.detail.includes('failed')) {
                    setShowResendVerification(false);
                    localStorage.removeItem("pendingVerificationEmail");
                }
            })
            .catch(err => {
                console.error('❌ Resend verification error:', err);
                console.error('Error response:', err.response?.data);
                setLoading(false);
                setClassName(`bg-red-100 border-t-4 border-red-500 rounded-b text-red-900 px-4 py-3 shadow-md transition duration-300 ease-in-out`);

                let errorMessage = 'Failed to resend verification email. ';

                if (err.response && err.response.data) {
                    if (err.response.data.detail) {
                        errorMessage = err.response.data.detail;
                    } else {
                        errorMessage += 'Please check your email configuration or contact support.';
                    }
                } else if (err.message) {
                    errorMessage += `Error: ${err.message}`;
                } else {
                    errorMessage += 'Unknown error occurred.';
                }

                setMessage(errorMessage);
                setShow(true);
                setTimeout(() => setShow(false), 7000); // Show error longer
            });
    };

    const googleAuth = () => {
        localStorage.setItem("socialAuth", "google");
        const clientID = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID;
        const callBackURI = `${CALLBACK_URI}/`;
        window.location.replace(`https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=${callBackURI}&prompt=consent&response_type=code&client_id=${clientID}&scope=openid%20email%20profile&access_type=offline`);
    };

    const githubAuth = () => {
        localStorage.setItem("socialAuth", "github");
        const clientID = process.env.REACT_APP_GITHUB_OAUTH_CLIENT_ID;
        const callBackURI = `${CALLBACK_URI}/`;
        window.location.replace(`https://github.com/login/oauth/authorize?redirect_uri=${callBackURI}&client_id=${clientID}&scope=user:email`);
    };

    const facebookAuth = () => {
        localStorage.setItem("socialAuth", "facebook");
        const clientID = process.env.REACT_APP_FACEBOOK_OAUTH_CLIENT_ID;
        const callBackURI = encodeURIComponent(`${CALLBACK_URI}/`); // Add encoding
        const state = "state123abc";
        window.location.replace(
            `https://www.facebook.com/v10.0/dialog/oauth?client_id=${clientID}&redirect_uri=${callBackURI}&state=${state}&response_type=code&scope=email,public_profile`
        );
    };


    return (
        <>
            <Form
                method="post"
                className1="w-full max-w-4xl"
                className2={isLogin ? "w-full lg:w-1/2" : "w-full"}
                action="/"
                onSubmit={isLogin ? LoginSubmit : forgotPassword ? ForgotPasswordSubmit : SignupSubmit}
                title={
                    <h4 className="mt-4 mb-6 pb-2">{isLogin ? "Sign In" : forgotPassword ? "Password Reset" : "Sign Up"}</h4>
                }
                onClose={() => setFormShow(false)}
                signinOptions={
                    isLogin && (
                        <>
                            <div className="flex items-center justify-center lg:justify-center">
                                <button
                                    type="button"
                                    className="btn bg-blue-500 text-white rounded-full p-1 mx-2"
                                    onClick={googleAuth}
                                >
                                    <i><bi.BiLogoGoogle size={32} /></i>
                                </button>
                                <button type="button" className="btn bg-blue-500 text-white rounded-full p-1 mx-2" onClick={facebookAuth}>
                                    <i><bi.BiLogoFacebook size={32} /></i>
                                </button>
                                <button type="button" className="btn bg-blue-500 text-white rounded-full p-1 mx-2" onClick={githubAuth}>
                                    <i><bi.BiLogoGithub size={32} /></i>
                                </button>
                            </div>
                            <div className="flex items-center justify-center my-4">
                                <p className="text-center font-bold mx-3 mb-0">Or</p>
                            </div>
                        </>
                    )
                }
                inputFields={
                    <>
                        {isLogin && (
                            <>
                                <div className="mb-4">
                                    <input
                                        type="text"
                                        id="username"
                                        name="username"
                                        value={username}
                                        onChange={e => setUsername(e.target.value)}
                                        className="form-input w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                                        placeholder="Username"
                                        required
                                    />
                                </div>
                                <div className="mb-4">
                                    <input
                                        type="password"
                                        id="password"
                                        name="password"
                                        value={password}
                                        onChange={e => setPassword(e.target.value)}
                                        className="form-input w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
                                        placeholder="Password"
                                        required
                                    />
                                </div>
                            </>

                        )}

                        {forgotPassword && (
                            <div className="mb-4">
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    className="form-input w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                                    placeholder="Email address"
                                    required
                                />
                            </div>
                        )}
                        {!isLogin && !forgotPassword && (
                            <>
                                <div className="mb-4">
                                    <input
                                        type="text"
                                        id="username"
                                        name="username"
                                        value={username}
                                        onChange={e => setUsername(e.target.value)}
                                        className="form-input w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                                        placeholder="Username"
                                        required
                                    />
                                </div>
                                <div className="mb-4">
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                        className="form-input w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                                        placeholder="Email address"
                                        required
                                    />
                                </div>
                                <div className="mb-4">
                                    <input
                                        type="password"
                                        id="password"
                                        name="password"
                                        value={password}
                                        onChange={e => setPassword(e.target.value)}
                                        className="form-input w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
                                        placeholder="Password"
                                        required
                                    />
                                </div>
                                <div className="mb-4">
                                    <input
                                        type="password"
                                        id="password2"
                                        name="password2"
                                        value={password2}
                                        onChange={e => setPassword2(e.target.value)}
                                        className="form-input w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                                        placeholder="Verify Password"
                                        required
                                    />
                                </div>

                            </>
                        )}
                        {/* Resend Verification Section */}
                        {showResendVerification && (
                            <div className="mb-4 p-4 bg-yellow-50 border-l-4 border-yellow-500 rounded">
                                <p className="text-sm text-yellow-800 mb-2">
                                    <strong>Didn't receive the verification email?</strong>
                                </p>
                                <p className="text-xs text-yellow-700 mb-3">
                                    Click below to resend the verification email to <strong>{verificationEmail}</strong>
                                </p>
                                <button
                                    type="button"
                                    onClick={ResendVerificationEmail}
                                    className="w-full px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-yellow-500 text-sm font-medium"
                                >
                                    Resend Verification Email
                                </button>
                            </div>
                        )}
                    </>
                }
                buttonOptions={
                    <>
                        <div className="text-center pt-1 mb-4 pb-2">
                            <button
                                className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-600 mb-3"
                                type="submit"
                            >
                                {isLogin ? "Log in" : forgotPassword ? "Request reset link" : "Sign Up"}
                            </button>
                            {isLogin ? (<Link className="text-gray-600 pt-2" onClick={(e) => {
                                e.preventDefault();
                                setIsLogin(false);
                                setForgotPassword(true);
                            }}>Forgot password?</Link>) : forgotPassword ? (<Link className="text-gray-600" onClick={(e) => {
                                e.preventDefault();
                                setIsLogin(true);
                                setForgotPassword(false);
                            }}>Go back to login?</Link>) : (<></>)}
                        </div>
                        {isLogin ? (<div className="flex items-center justify-center pb-4">
                            <p className="mb-0 mr-2">{isLogin ? "Don't have an account?" : "Already have an account?"}</p>
                            <button
                                onClick={(e) => {
                                    e.preventDefault();
                                    setIsLogin(false);
                                    const savedEmail = localStorage.getItem("pendingVerificationEmail");
                                    if (savedEmail) {
                                        setVerificationEmail(savedEmail);
                                        setShowResendVerification(true);
                                    }
                                }}
                                className="px-4 py-2 border border-b-blue-600 text-gray-600"
                            >
                                {isLogin ? "register here" : "login here"}
                            </button>
                        </div>) : forgotPassword ? (<></>) : (<div className="flex items-center justify-center pb-4">
                            <p className="mb-0 mr-2">{isLogin ? "Don't have an account?" : "Already have an account?"}</p>
                            <button
                                onClick={(e) => {
                                    e.preventDefault();
                                    setIsLogin(true);
                                }}
                                className="px-4 py-2 border border-b-blue-600 text-gray-600"
                            >
                                {isLogin ? "register here" : "login here"}
                            </button>
                        </div>)}
                    </>
                }
                extraContent={
                    isLogin && (
                        <div className="w-full lg:w-1/2 flex items-center bg-gradient-to-r from-purple-500 to-pink-500">
                            <div className="text-white px-6 py-8 md:p-12">
                                <h4 className="mb-4">We are more than just a company</h4>
                                <p className="text-sm">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                                    exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                            </div>
                        </div>
                    )
                }
            />
        </>
    );
};

export default Authenticate;